import { useEffect, useState } from "react";

/**
 * Returns a copy of `value` that only updates after `delayMs` of no changes.
 * Use to keep an input responsive while deferring expensive work (filtering,
 * fetching) until the user pauses typing.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
